/**
 * Masked birth date input helpers. pt-BR and pt-PT type DD/MM/AAAA; en-US
 * types MM/DD/YYYY. The API always receives ISO dates (YYYY-MM-DD).
 */

export function maskBirthDateInput(value: string): string {
  const numbers = value.replace(/\D/g, "");
  if (numbers.length <= 2) return numbers;
  if (numbers.length <= 4) return `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
  return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
}

/** Return the ISO date for a complete masked value, or "" when invalid. */
export function birthDateInputToIso(
  masked: string,
  dayFirst: boolean,
  today: Date = new Date(),
): string {
  const numbers = masked.replace(/\D/g, "");
  if (numbers.length !== 8) return "";

  const first = numbers.slice(0, 2);
  const second = numbers.slice(2, 4);
  const year = numbers.slice(4, 8);
  const [day, month] = dayFirst ? [first, second] : [second, first];

  const yearNum = Number(year);
  const monthNum = Number(month);
  const dayNum = Number(day);
  const date = new Date(yearNum, monthNum - 1, dayNum);
  if (
    yearNum < 1900 ||
    date.getFullYear() !== yearNum ||
    date.getMonth() !== monthNum - 1 ||
    date.getDate() !== dayNum ||
    date > today
  ) {
    return "";
  }

  return `${year}-${month}-${day}`;
}
